<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="10" :sm="24">
              <a-form-item label="关键字">
                <a-input
                  v-model="queryParam.keyword"
                  placeholder="账号、用户名或手机号"
                  allow-clear
                  @press-enter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['diandian:announcementAuditor:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['diandian:announcementAuditor:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['diandian:announcementAuditor:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAnnouncementAuditor, delAnnouncementAuditor } from '@/api/diandian/announcementAuditor'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'AnnouncementAuditor',
  components: { CreateForm },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        keyword: '',
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '序号', dataIndex: 'index', width: 64, align: 'center', customRender: (text, record, index) => index + 1 },
        { title: '用户名', dataIndex: 'nickName', width: 120, ellipsis: true, align: 'center' },
        { title: '账号', dataIndex: 'userName', width: 120, ellipsis: true, align: 'center' },
        { title: '手机号', dataIndex: 'phoneNumber', width: 120, align: 'center' },
        { title: '配置时间', dataIndex: 'createTime', width: 170, align: 'center', scopedSlots: { customRender: 'createTime' } },
        { title: '操作', dataIndex: 'operation', width: 150, align: 'center', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      const params = { ...this.queryParam }
      if (!params.keyword || !String(params.keyword).trim()) {
        delete params.keyword
      }
      pageAnnouncementAuditor(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        keyword: '',
        pageNum: 1,
        pageSize: this.queryParam.pageSize
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      const that = this
      const ids = row && row.id != null ? [row.id] : this.ids
      if (!ids.length) {
        return
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为 ' + ids.join(',') + ' 的数据',
        onOk () {
          const data = ids.map(id => ({ id: id }))
          return delAnnouncementAuditor(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        }
      })
    }
  }
}
</script>
